<template>
  <section class="purchase-process-section ly--outer--container">
    <div class="container">
      <!-- Content will be added here -->
      <div class="w-full" v-show="show">
        <h2 class="section-title">{{ $t("purchaseProcess.title") }}</h2>
        <p class="section-description">
          {{ $t("purchaseProcess.description") }}
        </p>
      </div>

      <div v-if="show && $i18n.locale === 'en'">
        <!-- progress bar START -->
        <div class="hk-progress-bar-container hk-anim-festive">
          <div class="hk-progress-bar-title">
            Shop Coffee and Accessories for Gifts up to $750 + $150 Credit
          </div>

          <div class="hk-progress-bar-tiers">
            <div class="hk-progress-bar-tier" id="tier1">
              <h3>Above HKD 888 to receive</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>Barista Mixologist<br />Stemmed Glass</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>Reversible Tote Bag</p>
                </div>
              </div>
            </div>
            <div class="hk-progress-bar-tier" id="tier2">
              <h3>Above HKD 1,288 to receive</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>Barista Mixologist<br />Stemmed Glass</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>Reversible Tote Bag</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?"
                  />
                  <p>Festive Limited<br />Edition Blanket</p>
                </div>
              </div>
            </div>
            <div class="hk-progress-bar-tier" id="tier3">
              <h3>Above HKD 1,488 to receive</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>Barista Mixologist<br />Stemmed Glass</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>Reversible Tote Bag</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?"
                  />
                  <p>Festive Limited<br />Edition Blanket</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46344355840030/Club-Credit.png?"
                  />
                  <p>
                    HKD150 Credit for next purchase<br />(Valid until March 31,
                    2026)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="hk-progress-bar-description" id="desc">
            Spend more to unlock gifts!
          </div>

          <div class="hk-progress-bar-progress-bar">
            <div class="hk-progress-bar-progress" id="progress"></div>
            <img
              id="icon"
              src="https://www.nespresso.com/ecom/medias/sys_master/public/45772094242846/C-1350-OL-ResponsiveStandard.png?impolicy=product&imwidth=58"
              class="hk-progress-bar-icon"
              alt="Progress Icon"
            />
          </div>
        </div>
        <!-- progress bar END -->

        <!-- gift detail START -->
        <div class="callout-hk-root">
          <!-- Trigger -->
          <div class="callout-hk-page-actions">
            <a
              id="hk-openCallout"
              class="callout-hk-btn"
              role="button"
              aria-haspopup="dialog"
              aria-controls="hk-giftCallout"
            >
              🎁 View Gifts Details
            </a>
          </div>

          <!-- Callout (Modal) -->
          <div
            id="hk-giftCallout"
            class="callout-hk-callout"
            hidden
            role="dialog"
            aria-modal="true"
            aria-labelledby="hk-calloutTitle"
          >
            <div class="callout-hk-overlay" data-close></div>

            <div class="callout-hk-panel" role="document">
              <section
                class="callout-hk-surface"
                aria-labelledby="hk-calloutTitle"
              >
                <img
                  class="callout-hk-corner-img callout-hk-corner-img--top-left"
                  src="https://www.nespresso.com/ecom/medias/sys_master/public/46454636150814/icon-200x200.png?"
                />
                <!-- Header with centered title -->
                <div class="callout-hk-surface-head">
                  <span
                    class="callout-hk-head-spacer"
                    aria-hidden="true"
                  ></span>
                  <h2 id="hk-calloutTitle" class="callout-hk-title">
                    Festive Gifts Details
                  </h2>
                  <button
                    class="callout-hk-close"
                    type="button"
                    aria-label="Close"
                    title="Close"
                    data-close
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M6 6l12 12M18 6L6 18"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <!-- OFFERS (tiers) -->
                <section
                  class="callout-hk-offers"
                  aria-labelledby="hk-offersTitle"
                >
                  <h3 id="hk-offersTitle" class="callout-hk-offers-title">
                    Offer Details:
                  </h3>
                  <div class="callout-hk-offers-grid" role="list">
                    <!-- Tier 1 -->
                    <article
                      class="callout-hk-offer is-1"
                      role="listitem"
                      aria-label="Tier 1: Shop coffee above HKD888"
                    >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >Shop Coffee or Accessories above
                          <strong>HKD888</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- Barista Mixologist High Stemmed Glass</li>
                        <li>- Reversible Tote Bag</li>
                      </ul>
                    </article>

                    <!-- Tier 2 -->
                    <article
                      class="callout-hk-offer is-2"
                      role="listitem"
                      aria-label="Tier 2: Shop coffee above HKD1,288"
                    >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >Shop Coffee or Accessories above
                          <strong>HKD1,288</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- Everything in Offer 1</li>
                        <li>
                          - <strong>Extra:</strong> Festive Limited Edition
                          Blanket
                        </li>
                      </ul>
                    </article>

                    <!-- Tier 3 -->
                    <article
                      class="callout-hk-offer is-3"
                      role="listitem"
                      aria-label="Tier 3: Shop coffee above HKD1,488"
                    >
                      <!-- Corner label -->
                      <span class="callout-hk-offer-flag" aria-hidden="true"
                        >BEST VALUE</span
                      >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >Shop Coffee or Accessories above
                          <strong>HKD1,488</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- Everything in Offer 2</li>
                        <li>- <strong>Extra:</strong> HKD150 Club Credit</li>
                      </ul>
                    </article>
                  </div>
                </section>

                <div class="callout-hk-surface-body">
                  <!-- LEFT: Accordion -->
                  <aside class="callout-hk-accordion" aria-label="Gift list">
                    <!-- Glass -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-1"
                        aria-expanded="true"
                        aria-controls="hk-gift-panel-1"
                        data-index="1"
                        data-label="Above HKD888"
                        data-title="Barista Mixologist Stemmed Glass"
                        data-images="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass_2x.png|https://www.nespresso.com/ecom/medias/sys_master/public/46453795749918/Glass-lifestyle.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">Above HKD888</span>
                          <span class="callout-hk-acc-title"
                            >Barista Mixologist High Stemmed Glass</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-1"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-1"
                        data-open="true"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- Capacity, 300ml 13.5 cm, Ø 11 cm</li>
                            <li>
                              - Cold Recipes: Your Beverage, the way you like it
                            </li>
                            <li>- Material: Glass</li>
                          </ul>
                          <p class="callout-hk-desc">
                            No matter the time of year, the Barista Mixologist
                            Stemmed Glasses designed by Federico Peri make
                            celebrations unique. With a slender stem and
                            vertical stripes that dance around the glass, you
                            can experiment between the lines, or outside the
                            lines.
                          </p>
                        </div>
                        <!-- Mobile docking slot -->
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>

                    <!-- Tote -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-2"
                        aria-expanded="false"
                        aria-controls="hk-gift-panel-2"
                        data-index="2"
                        data-label="Above HKD888"
                        data-title="Reversible Tote Bag"
                        data-images="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag_2x.png|https://www.nespresso.com/ecom/medias/sys_master/public/46345226420254/Tote-label.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">Above HKD888</span>
                          <span class="callout-hk-acc-title"
                            >Reversible Tote Bag</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-2"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-2"
                        data-open="false"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- Dimensions (W × H × D): 46 × 41 × 12 cm</li>
                            <li>- Cleaning: Handwash only</li>
                            <li>
                              - Warning: Do not bleach, do not tumble dry, line
                              dry, do not iron, do not dry clean
                            </li>
                          </ul>
                          <p class="callout-hk-desc">
                            A reversible tote bag in 100% recycled cotton,
                            perfect for festive gift shopping. Enjoy two styles
                            in one: a sleek solid colour or the joyful pattern
                            designed by artist Thandiwe Muriu. An elegant
                            companion to elevate every moment.
                          </p>
                        </div>
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>

                    <!-- Blanket (3 images) -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-3"
                        aria-expanded="false"
                        aria-controls="hk-gift-panel-3"
                        data-index="3"
                        data-label="Above HKD1,288"
                        data-title="Festive Limited Edition Blanket"
                        data-images="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46293965078558/blanket-candy.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46293965766686/blanket-square.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46453796044830/blanket-lifestyle.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">Above HKD1,288</span>
                          <span class="callout-hk-acc-title"
                            >Festive Limited Edition Blanket</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-3"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-3"
                        data-open="false"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- Dimensions (W × H): 130 × 140 cm</li>
                            <li>- Cleaning: Handwash only</li>
                            <!-- UPDATED bullets below -->
                            <li>
                              - Material:<br />Front: 100% Recycled Polyester<br />Back:
                              100% Polyester
                            </li>
                            <li>- Made in China</li>
                          </ul>
                          <p class="callout-hk-desc">
                            While counting down the days to the festive season
                            and searching for the perfect gift, enjoy
                            Nespresso's limited edition festive blanket to warm
                            and brighten one's home. Be inspired by coffee
                            flower patterns and recycled fabrics showcasing
                            jacquard weaving. This season, Nespresso invites you
                            to celebrate the "Magic" of everyday and every
                            moment.
                          </p>
                        </div>
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>
                  </aside>

                  <!-- RIGHT: Preview host (hidden on mobile; preview docks under the open tab) -->

                  <div class="callout-hk-preview-host">
                    <section class="callout-hk-preview" aria-live="polite">
                      <div class="callout-hk-preview-head">
                        <span id="hk-previewLabel" class="callout-hk-badge"
                          >Above HKD888</span
                        >
                      </div>

                      <figure
                        class="callout-hk-preview-fig"
                        aria-describedby="hk-previewLabel"
                      >
                        <img
                          id="hk-previewImage"
                          alt="Barista Mixologist Stemmed Glass large image"
                          glass_2x.png
                        />
                        <!-- Overlay arrows INSIDE the figure -->
                        <button
                          type="button"
                          class="callout-hk-fig-nav callout-hk-fig-nav--prev"
                          data-fig="prev"
                          aria-label="Previous image"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M15 6l-6 6 6 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="callout-hk-fig-nav callout-hk-fig-nav--next"
                          data-fig="next"
                          aria-label="Next image"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M9 6l6 6-6 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </figure>

                      <!-- Thumbnails (centered below the figure) -->
                      <div
                        class="callout-hk-thumbs"
                        id="hk-thumbStrip"
                        aria-label="Preview thumbnails"
                      ></div>
                    </section>
                  </div>
                </div>
                <img
                  class="callout-hk-corner-img callout-hk-corner-img--bottom-right"
                  src="https://www.nespresso.com/ecom/medias/sys_master/public/46454636150814/icon-200x200.png?"
                />
              </section>
            </div>
          </div>
        </div>
        <!-- gift detail END -->
      </div>
      <div v-else-if="show">
        <!-- progress bar START -->
        <div class="hk-progress-bar-container hk-anim-festive">
          <div class="hk-progress-bar-title">
            購買咖啡或咖啡配件可獲贈高達 HKD750禮品及 HKD150會員積分
          </div>

          <div class="hk-progress-bar-tiers">
            <div class="hk-progress-bar-tier" id="tier1">
              <h3>購買滿 HKD888以上可獲贈</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>調酒師高腳咖啡杯</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>限量版雙面手提袋</p>
                </div>
              </div>
            </div>
            <div class="hk-progress-bar-tier" id="tier2">
              <h3>購買滿 HKD1,288以上可獲贈</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>調酒師高腳咖啡杯</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>限量版雙面手提袋</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?"
                  />
                  <p>節日限量版毛毯</p>
                </div>
              </div>
            </div>
            <div class="hk-progress-bar-tier" id="tier3">
              <h3>購買滿 HKD1,488以上可獲贈</h3>
              <div class="hk-progress-bar-gwps">
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass.png"
                  />
                  <p>調酒師高腳咖啡杯</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag.png"
                  />
                  <p>限量版雙面手提袋</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?"
                  />
                  <p>節日限量版毛毯</p>
                </div>
                <div class="hk-progress-bar-gwp">
                  <img
                    src="https://www.nespresso.com/ecom/medias/sys_master/public/46344355840030/Club-Credit.png?"
                  />
                  <p>HKD150會員積分供下次購物<br />(有效期至2026年3月31日)</p>
                </div>
              </div>
            </div>
          </div>
          <div class="hk-progress-bar-description" id="desc">
            解鎖你的專屬驚喜！
          </div>

          <div class="hk-progress-bar-progress-bar">
            <div class="hk-progress-bar-progress" id="progress"></div>
            <img
              id="icon"
              src="https://www.nespresso.com/ecom/medias/sys_master/public/45772094242846/C-1350-OL-ResponsiveStandard.png?impolicy=product&imwidth=58"
              class="hk-progress-bar-icon"
              alt="Progress Icon"
            />
          </div>
        </div>
        <!-- progress bar END -->

        <!-- gift detail START -->
        <div class="callout-hk-root">
          <!-- Trigger -->
          <div class="callout-hk-page-actions">
            <a
              id="hk-openCallout"
              class="callout-hk-btn"
              role="button"
              aria-haspopup="dialog"
              aria-controls="hk-giftCallout"
            >
              🎁 查看禮品詳情
            </a>
          </div>

          <!-- Callout (Modal) -->
          <div
            id="hk-giftCallout"
            class="callout-hk-callout"
            hidden
            role="dialog"
            aria-modal="true"
            aria-labelledby="hk-calloutTitle"
          >
            <div class="callout-hk-overlay" data-close></div>

            <div class="callout-hk-panel" role="document">
              <section
                class="callout-hk-surface"
                aria-labelledby="hk-calloutTitle"
              >
                <img
                  class="callout-hk-corner-img callout-hk-corner-img--top-left"
                  src="https://www.nespresso.com/ecom/medias/sys_master/public/46454636150814/icon-200x200.png?"
                />
                <!-- Header with centered title -->
                <div class="callout-hk-surface-head">
                  <span
                    class="callout-hk-head-spacer"
                    aria-hidden="true"
                  ></span>
                  <h2 id="hk-calloutTitle" class="callout-hk-title">
                    佳節禮品詳情
                  </h2>
                  <button
                    class="callout-hk-close"
                    type="button"
                    aria-label="Close"
                    title="Close"
                    data-close
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M6 6l12 12M18 6L6 18"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <!-- OFFERS (tiers) -->
                <section
                  class="callout-hk-offers"
                  aria-labelledby="hk-offersTitle"
                >
                  <h3 id="hk-offersTitle" class="callout-hk-offers-title">
                    優惠詳情:
                  </h3>
                  <div class="callout-hk-offers-grid" role="list">
                    <!-- Tier 1 -->
                    <article
                      class="callout-hk-offer is-1"
                      role="listitem"
                      aria-label="Tier 1: Shop coffee above HKD888"
                    >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >購買咖啡或咖啡配件滿 <strong>HKD888</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- 調酒師高腳咖啡杯</li>
                        <li>- 限量版雙面手提袋</li>
                      </ul>
                    </article>

                    <!-- Tier 2 -->
                    <article
                      class="callout-hk-offer is-2"
                      role="listitem"
                      aria-label="Tier 2: Shop coffee above HKD1,288"
                    >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >購買咖啡或咖啡配件滿 <strong>HKD1,288</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- 優惠1 的所有禮品</li>
                        <li>- <strong>額外:</strong> 節日限量版毛毯</li>
                      </ul>
                    </article>

                    <!-- Tier 3 -->
                    <article
                      class="callout-hk-offer is-3"
                      role="listitem"
                      aria-label="Tier 3: Shop coffee above HKD1,488"
                    >
                      <!-- Corner label -->
                      <span class="callout-hk-offer-flag" aria-hidden="true"
                        >超值優惠</span
                      >
                      <div class="callout-hk-offer-head">
                        <span class="callout-hk-offer-tier"
                          >購買咖啡或咖啡配件滿 <strong>HKD1,488</strong></span
                        >
                        <span class="callout-hk-offer-qualify"></span>
                      </div>
                      <ul class="callout-hk-offer-list">
                        <li>- 優惠2 的所有禮品</li>
                        <li>- <strong>額外:</strong> HKD150 會員積分</li>
                      </ul>
                    </article>
                  </div>
                </section>

                <div class="callout-hk-surface-body">
                  <!-- LEFT: Accordion -->
                  <aside class="callout-hk-accordion" aria-label="Gift list">
                    <!-- Glass -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-1"
                        aria-expanded="true"
                        aria-controls="hk-gift-panel-1"
                        data-index="1"
                        data-label="滿 HKD888"
                        data-title="Barista Mixologist Stemmed Glass"
                        data-images="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-stemmed-glass_2x.png|https://www.nespresso.com/ecom/medias/sys_master/public/46453795749918/Glass-lifestyle.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">滿 HKD888</span>
                          <span class="callout-hk-acc-title"
                            >調酒師高腳咖啡杯</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-1"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-1"
                        data-open="true"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- 容量, 300毫升/ 高13.5厘米, 直徑11厘米</li>
                            <li>- 凍飲食譜: 可用於隨心創作喜歡的凍飲</li>
                            <li>- 材質: 玻璃</li>
                          </ul>
                          <p class="callout-hk-desc">
                            Barista 調酒高腳玻璃杯由 Federico Peri
                            設計，杯腳纖細優雅，垂直條紋環繞杯身，在線條交織之間，呈獻品味非凡的咖啡體驗，令您每個慶祝場合更顯獨一無二。
                          </p>
                        </div>
                        <!-- Mobile docking slot -->
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>

                    <!-- Tote -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-2"
                        aria-expanded="false"
                        aria-controls="hk-gift-panel-2"
                        data-index="2"
                        data-label="滿 HKD888"
                        data-title="Reversible Tote Bag"
                        data-images="https://www.nespresso.com/shared_res/agility/global/campaigns/festive-2025/sku-main-info-product/festive-2025-tote-bag_2x.png|https://www.nespresso.com/ecom/medias/sys_master/public/46345226420254/Tote-label.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">滿 HKD888</span>
                          <span class="callout-hk-acc-title"
                            >限量版雙面手提袋</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-2"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-2"
                        data-open="false"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- 體積(闊x高x深): 46 x 41 x 12 厘米</li>
                            <li>- 清洗: 只限手洗</li>
                            <li>
                              - 警告:
                              切勿漂白或烘乾，請懸掛晾乾。不可熨燙或乾洗。
                            </li>
                          </ul>
                          <p class="callout-hk-desc">
                            此雙面手提袋採用100%再生棉製成，可將時尚純色的一面與藝術家
                            Thandiwe Muriu
                            設計的繽紛圖案正反互換，為每個出遊時刻增添優雅格調，是節日佳禮之選。
                          </p>
                        </div>
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>

                    <!-- Blanket (3 images) -->
                    <article class="callout-hk-acc-item">
                      <button
                        class="callout-hk-acc-trigger"
                        id="hk-gift-trigger-3"
                        aria-expanded="false"
                        aria-controls="hk-gift-panel-3"
                        data-index="3"
                        data-label="滿 HKD1,288"
                        data-title="Festive Limited Edition Blanket"
                        data-images="https://www.nespresso.com/ecom/medias/sys_master/public/46271704858654/Blanket-2.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46293965078558/blanket-candy.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46293965766686/blanket-square.png?|https://www.nespresso.com/ecom/medias/sys_master/public/46453796044830/blanket-lifestyle.png?"
                      >
                        <span class="callout-hk-acc-meta">
                          <span class="callout-hk-badge">滿 HKD1,288</span>
                          <span class="callout-hk-acc-title"
                            >節日限量版毛毯</span
                          >
                        </span>
                        <span aria-hidden="true" class="callout-hk-chev">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 9l6 6 6-6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </button>
                      <div
                        id="hk-gift-panel-3"
                        class="callout-hk-acc-region"
                        role="region"
                        aria-labelledby="hk-gift-trigger-3"
                        data-open="false"
                      >
                        <div class="callout-hk-acc-inner">
                          <ul class="callout-hk-bullets">
                            <li>- 體積(闊x高): 130 × 140 厘米</li>
                            <li>- 清洗: 只限手洗</li>
                            <!-- UPDATED bullets below -->
                            <li>
                              - 材質:<br />正面: 100% 再生纖維<br />背面: 100%
                              纖維
                            </li>
                            <li>- 中國製造</li>
                          </ul>
                          <p class="callout-hk-desc">
                            從節日倒數的雀躍心情，到挑選完美禮物的心意，以Nespresso佳節限量版毛毯點亮冬日居家暖意。
                            Nespresso佳節限量版毛毯以綻放的咖啡花朵為靈感，選用再生面料演繹雙面提花編織工藝的極致色彩美學，這個冬季，Nespresso邀請您慶祝節日與日常生活中的每一個「煥魅」時刻。
                          </p>
                        </div>
                        <div
                          class="callout-hk-mobile-slot"
                          data-mobile-slot
                          aria-hidden="true"
                        ></div>
                      </div>
                    </article>
                  </aside>

                  <!-- RIGHT: Preview host (hidden on mobile; preview docks under the open tab) -->

                  <div class="callout-hk-preview-host">
                    <section class="callout-hk-preview" aria-live="polite">
                      <div class="callout-hk-preview-head">
                        <span id="hk-previewLabel" class="callout-hk-badge"
                          >滿 HKD888</span
                        >
                      </div>

                      <figure
                        class="callout-hk-preview-fig"
                        aria-describedby="hk-previewLabel"
                      >
                        <img
                          id="hk-previewImage"
                          alt="Barista Mixologist Stemmed Glass large image"
                          glass_2x.png
                        />
                        <!-- Overlay arrows INSIDE the figure -->
                        <button
                          type="button"
                          class="callout-hk-fig-nav callout-hk-fig-nav--prev"
                          data-fig="prev"
                          aria-label="Previous image"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M15 6l-6 6 6 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="callout-hk-fig-nav callout-hk-fig-nav--next"
                          data-fig="next"
                          aria-label="Next image"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M9 6l6 6-6 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </figure>

                      <!-- Thumbnails (centered below the figure) -->
                      <div
                        class="callout-hk-thumbs"
                        id="hk-thumbStrip"
                        aria-label="Preview thumbnails"
                      ></div>
                    </section>
                  </div>
                </div>
                <img
                  class="callout-hk-corner-img callout-hk-corner-img--bottom-right"
                  src="https://www.nespresso.com/ecom/medias/sys_master/public/46454636150814/icon-200x200.png?"
                />
              </section>
            </div>
          </div>
        </div>
        <!-- gift detail END -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PurchaseProcessSection",

  /**
   * Component data properties
   * @returns {Object} Component data
   */
  data() {
    return {
      // Component data will be added here as needed
      show: false,
    };
  },

  /**
   * Component computed properties
   */
  computed: {
    // Computed properties will be added here as needed
  },

  /**
   * Component methods
   */
  methods: {
    // Component methods will be added here as needed
    mounted() {},
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .purchase-process-section {
    margin-top: rem(-137);
    padding-top: rem(200);
    padding-bottom: 6.5rem;
    background: linear-gradient(
      90deg,
      color(gradientStart) 0%,
      color(gradientEnd) 100%
    );

    .section-title {
      font-size: rem(32);
      font-weight: 600;
      color: color(darkText);
      margin-bottom: rem(16);
      text-align: center;

      @include media-breakpoint-down(md) {
        font-size: rem(24);
      }
    }

    .section-description {
      font-size: rem(16);
      color: color(mediumGray);
      text-align: center;
      margin-bottom: rem(32);

      @include media-breakpoint-down(md) {
        font-size: rem(14);
      }
    }
  }
}
</style>
